interface Props {
  embedUrl: string;
  isHost: boolean;
  onClose: () => void;
}

/** Lecteur YouTube partagé par l'hôte pendant la réunion. */
export default function YoutubePanel({ embedUrl, isHost, onClose }: Props) {
  return (
    <div className="w-[380px] max-w-[calc(100vw-2rem)] bg-background-950 rounded-xl overflow-hidden border border-white/10">
      <div className="flex items-center justify-between px-3 py-2 border-b border-white/10">
        <span className="text-xs font-semibold text-white flex items-center gap-2">
          <i className="ri-youtube-line text-red-400"></i>Vidéo partagée
        </span>
        {isHost && (
          <button onClick={onClose} className="w-6 h-6 rounded-full flex items-center justify-center text-white/50 hover:bg-white/10 cursor-pointer" title="Arrêter">
            <i className="ri-close-line text-sm"></i>
          </button>
        )}
      </div>
      <div className="aspect-video bg-black">
        <iframe
          src={embedUrl}
          title="Vidéo YouTube"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="w-full h-full border-0"
        />
      </div>
    </div>
  );
}